import GoogleMapReact from 'google-map-react'

import IconMapPin from '../../../../../assets/icons/IconMapPin'

import MapTooltip from './MapTooltip'
import DeliveryPointInfo from './DeliveryPointInfo'
import { useIsFetching} from 'react-query';
import styles from './styles'
import Loader from '../../../Loader';

const Place = ({ selectPlace, place }) => (
  <div>
    <IconMapPin onClick={selectPlace} />
    <MapTooltip
      data={{
        businessName: place.name,
        address: place.address,
        distance: 2.1,
      }}
    />
  </div>
)

const SPAIN = {
  lat: 40.4165,
  lng: -3.70256,
}

function Map({
  confirmPlace,
  center,
  zoom,
  addresses,
  selectAddress,
  selectedPlace,
  selectedAddress,
  deselectAddress,
}) {
  const defaultProps = {
    center: SPAIN,
    zoom: 11,
  }

  const fetching = useIsFetching()
  
  return (
    // Important! Always set the container height explicitly
    <div
      style={{
        height: '100vh',
        width: '100%',
        maxHeight: '400px',
        position: 'relative',
      }}
    >
      <GoogleMapReact
        key={`${center?.lat}-${center?.lng}-${zoom}`}
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAP_API_KEY }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        center={center}
        zoom={zoom}
      >
        {fetching
          ? <div style={styles.loader}>
            <Loader size={100} />
          </div>
          :null
        }
        {selectedAddress !== undefined ? (
          <DeliveryPointInfo
                data={{
                  businessName: selectedAddress.name,
                  address: selectedAddress.address,
                  distance: null,
                  schedule: selectedAddress.schedule,
                  phone: selectedAddress.phoneNumber,
                }}
                onClose={deselectAddress}
              />
      ) : null}
        {addresses?.map(place => (
          <Place
            key={`${place.lat}/${place.lng}`}
            lat={place.lat}
            lng={place.lng}
            place={place}
            selectPlace={() => {
              selectAddress(place)
            }}
          />
        ))}
      </GoogleMapReact>
    </div>
  )
}

export default Map
